import { useState } from 'react'
import { Box, IconButton, Typography, Grid, Divider } from '@mui/material'
import { FilterButton } from '@/components/common'
import { TableLimit } from '@/@core/components/mui/TableLimit'
import { useRouteQuery, useTranslator } from '@/hooks'
import AppLogs from '@/components/common/AppLogs'
import { ActivityLogTypeEnum } from '@/@data'
import TransactionEmployeeStatusSelection from '@/components/selection/TransactionEmployeeStatusSelection'
import InputDateRangerField from '@/components/common/input/InputDateRangerField'
import { SearchInput } from '@/components/common/SearchInput'

interface SettingFinanceFilterProps {
  onSearch?: (value: string) => void
  onAddEmployee?: () => void
}

export const SettingFinanceFilter = ({}: SettingFinanceFilterProps) => {
  const { __ } = useTranslator()
  const { updateQuery, searchQuery } = useRouteQuery()
  const [filter, setFilter] = useState(true)
  const [isOpenLogs, setIsOpenLogs] = useState(false)

  return (
    <Box
      sx={{
        display: 'flex',
        padding: '20px',
        gap: 4,
        flexDirection: 'column'
      }}
    >
      {filter && (
        <>
          <Box className='mb-3'>
            <Typography variant='h6' className='mb-3'>
              {__('Filters')}
            </Typography>
            <Grid container spacing={2}>
              <Grid size={6}>
                <InputDateRangerField
                  value={
                    searchQuery.get('contract_start_date')
                      ? [
                          searchQuery.get('contract_start_date') as string,
                          searchQuery.get('contract_end_date') as string
                        ]
                      : []
                  }
                  onChange={created_at => {
                    if (created_at) {
                      updateQuery({ contract_start_date: created_at[0], contract_end_date: created_at[1], page: 1 })
                    } else {
                      updateQuery({ contract_start_date: undefined, contract_end_date: undefined, page: 1 })
                    }
                  }}
                />
              </Grid>
              <Grid size={6}>
                <TransactionEmployeeStatusSelection
                  value={searchQuery.get('status') || ''}
                  onSelect={status => updateQuery({ status, page: 1 })}
                  placeholder={__('All')}
                  queryParam='status'
                />
              </Grid>
            </Grid>
          </Box>
          <Divider />
        </>
      )}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        <TableLimit />

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <div className='w-[240px]'>
            <SearchInput
              placeholder={__('Search Company')}
              onSearch={value => {
                updateQuery({ keywords: value, page: 1 })
              }}
              initialValue={searchQuery.get('keywords') || ''}
            />
          </div>

          <FilterButton filter={filter} onFilter={() => setFilter(!filter)} />

          <IconButton
            size='small'
            sx={{
              width: 40,
              height: 40,
              backgroundColor: '#f5f5f5',
              '&:hover': {
                backgroundColor: '#e0e0e0'
              }
            }}
            onClick={() => setIsOpenLogs(true)}
          >
            <i className='tabler-history text-[#2f2b3de6]' style={{ fontSize: 18 }} />
          </IconButton>
          <AppLogs
            open={isOpenLogs}
            setOpen={setIsOpenLogs}
            title={__('History Menu Setting Finance')}
            object_type={ActivityLogTypeEnum.SettingFinance}
          />
        </Box>
      </Box>
    </Box>
  )
}
